export default {
  "site.name": "AllChinaBuy Spreadsheet",
  "site.title": "AllChinaBuy Spreadsheet - Produits, Vendeurs & Guides d'Achat",
  "site.description": "Explorez les ressources AllChinaBuy spreadsheet, les découvertes produits, la recherche vendeurs, les guides QC, les informations d'expédition, les conseils d'entrepôt et les guides d'achat pratiques — organisés dans un hub de ressources facile à utiliser.",
  "nav.spreadsheet": "Spreadsheet",
  "nav.categories": "Catégories",
  "nav.guides": "Guides",
  "nav.review": "Avis",
  "nav.shipping": "Expédition",
  "nav.qc": "QC",
  "nav.safety": "Sécurité",
  "nav.faq": "FAQ",
  "nav.home": "Accueil",
  "nav.shoppingGuide": "Guide d'Achat",
  "hero.eyebrow": "HUB DE RESSOURCES ALLCHINABUY SPREADSHEET",
  "hero.title": "AllChinaBuy Spreadsheet — Trouvez Produits, Vendeurs & Guides d'Achat en Un Seul Endroit",
  "hero.description": "Explorez les ressources AllChinaBuy spreadsheet, les découvertes produits, la recherche vendeurs, les guides QC, les informations d'expédition, les conseils d'entrepôt et les guides d'achat pratiques — organisés dans un hub de ressources facile à utiliser.",
  "hero.cta1": "Explorer le AllChinaBuy Spreadsheet",
  "hero.cta2": "Acheter Maintenant",
  "hero.trust": "Ressource Indépendante · Mise à Jour Régulière · Multilingue · Guides de Sécurité",
  "categories.title": "Catégories de Produits",
  "categories.description": "Parcourez nos catégories de produits sélectionnées et trouvez exactement ce dont vous avez besoin sur AllChinaBuy Spreadsheet.",
  "categories.select": "Sélectionner une Catégorie",
  "articles.title": "Guides AllChinaBuy Spreadsheet",
  "articles.description": "Guides et ressources complets pour vous aider à naviguer dans l'expérience AllChinaBuy Spreadsheet.",
  "articles.readMore": "Lire le Guide",
  "cta.title": "Prêt à Commencer vos Achats ?",
  "cta.description": "Visitez le site principal AllChinaBuy Spreadsheet pour explorer les produits, comparer les prix et effectuer vos achats en toute confiance.",
  "cta.mainSite": "Visiter AllChinaBuy Spreadsheet",
  "cta.buyNow": "Acheter Maintenant",
  "footer.spreadsheet": "Spreadsheet",
  "footer.categories": "Catégories",
  "footer.sellers": "Vendeurs",
  "footer.guides": "Guides",
  "footer.review": "Avis",
  "footer.shipping": "Expédition",
  "footer.qc": "QC",
  "footer.warehouse": "Entrepôt",
  "footer.safety": "Sécurité",
  "footer.resources": "Ressources",
  "footer.articles": "Articles",
  "footer.faq": "FAQ",
  "footer.comparisons": "Comparaisons",
  "footer.company": "Entreprise",
  "footer.about": "À Propos",
  "footer.contact": "Contact",
  "footer.privacy": "Politique de Confidentialité",
  "footer.terms": "Conditions d'Utilisation",
  "footer.disclaimer": "AllChinaBuySpread est une ressource d'information indépendante et n'est pas le site officiel d'AllChinaBuy.",
  "footer.language": "Langue",
  "lang.en": "English",
  "lang.fr": "Français",
  "lang.de": "Deutsch",
  "lang.da": "Dansk",
  "article.published": "Publié",
  "article.readTime": "min de lecture",
  "article.backToHome": "Retour à l'Accueil",
  "article.relatedArticles": "Articles Connexes",
  "article.tableOfContents": "Table des Matières",
  "whatIs.title": "Qu'est-ce que AllChinaBuy Spreadsheet ?",
  "whatIs.description": "AllChinaBuy Spreadsheet est un hub de ressources complet conçu pour aider les acheteurs à naviguer dans le monde complexe de l'achat international. Nous organisons les listes de produits, les avis des vendeurs, les guides d'expédition et les informations de contrôle qualité pour rendre votre expérience d'achat fluide et sécurisée.",
  "trust.title": "Pourquoi Faire Confiance à AllChinaBuy Spreadsheet ?",
  "trust.item1": "Ressource indépendante sans affiliation avec les vendeurs",
  "trust.item2": "Catégories de produits et tarifs régulièrement mis à jour",
  "trust.item3": "Support multilingue pour les acheteurs du monde entier",
  "trust.item4": "Guides de sécurité et de QC complets",
  "seo.article1.title": "Guide Complet AllChinaBuy Spreadsheet",
  "seo.article1.desc": "Un guide complet pour utiliser AllChinaBuy Spreadsheet pour la recherche de produits, la comparaison de prix et la recherche de vendeurs de confiance.",
  "seo.article1.date": "Août 2026",
  "seo.article1.readTime": "8",
};